import { useScrollReveal } from '../../../hooks/useScrollReveal';

const services = [
  {
    title: 'Criação de Identidade Visual',
    image: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/8cbf4b5e559ced1c3e4501654dd7a169.jpeg',
  },
  {
    title: 'Social Media',
    image: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/c675fd69322e94a075b3f409f0f4d13a.jpeg',
  },
  {
    title: 'Mídias Digitais',
    image: 'https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/0a4138272f170596b2670fd821947e6a.jpeg',
  }
];

export function Services() {
  const titleRef = useScrollReveal();
  const card1Ref = useScrollReveal();
  const card2Ref = useScrollReveal();
  const card3Ref = useScrollReveal();

  const cardRefs = [card1Ref, card2Ref, card3Ref];

  return (
    <section id="servicos" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={titleRef} className="text-center mb-16 scroll-reveal">
          <p className="text-sm text-gray-400 mb-2 tracking-widest uppercase">GUEPARDO AGENCIA</p>
          <h2 className="text-5xl font-black text-white mb-4">Serviços</h2>
          <div className="w-16 h-1 bg-gradient-to-r from-amber-200 to-amber-100 mx-auto mt-4"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              ref={cardRefs[index]}
              className="group relative h-80 rounded-2xl overflow-hidden cursor-pointer scroll-reveal-scale"
              style={{ transitionDelay: `${index * 0.15}s` }}
            >
              {/* Imagem de fundo */}
              <div 
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                style={{ backgroundImage: `url(${service.image})` }}
              ></div>
              
              {/* Overlay gradiente */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500"></div>
              
              {/* Conteúdo */}
              <div className="absolute inset-0 flex flex-col justify-end p-8">
                <h3 className="text-2xl font-bold text-white mb-4 transform transition-transform duration-500 group-hover:translate-y-[-8px]">
                  {service.title}
                </h3>
                
                <a
                  href="https://api.whatsapp.com/send?phone=5519982674838&text=Olá, gostaria de saber mais sobre os serviços da GUEPARDO AGENCIA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-amber-200 to-amber-300 text-black font-bold py-3 px-6 rounded-full opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-500 whitespace-nowrap hover:shadow-lg hover:shadow-amber-200/50"
                >
                  Solicitar orçamento
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}